import axios from 'axios';
import { API_BASE_URI } from '../appConfig';

const client = axios.create({
  baseURL: API_BASE_URI
});

export default client;
